import Project1 from "../Project/Project1";
import Project2 from "../Project/Project2";
import Project3 from "../Project/Project3";

const Projects = () => {
  return (
    <div id="projects">
      <h2 className="bg-[#f9f9f9] text-center text-2xl text-[#2979ff] font-bold tracking-[.10em] uppercase pt-24 lg:py-20 lg:pt-32">
        My Recent Work
      </h2>
      <div>
        <Project1></Project1>
        <Project2></Project2>
        <Project3></Project3>
      </div>
    </div>
  );
};

export default Projects;
